import { render } from "./QuestionBank.vue?vue&type=template&id=be29ea36&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"

import "./QuestionBank.vue?vue&type=style&index=0&id=be29ea36&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be29ea36"]])

export default __exports__